/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".title[_ngcontent-%COMP%]{font-size:24px;padding:48px 0 18px;color:#27201a;font-weight:300}.title[_ngcontent-%COMP%]:first-of-type{padding-top:0}.title.input-title[_ngcontent-%COMP%]{color:#231d19}app-controls[_ngcontent-%COMP%]{margin-top:24px}voxel-form-field[_ngcontent-%COMP%]  .voxel-form-field__label{color:#56504c;font-family:\"Itau Display\"}.spacing[_ngcontent-%COMP%]{padding-bottom:15px}"];
export { styles as styles };
